import { createFileRoute } from '@tanstack/react-router'
import { AvailableChallengesPage } from '../../components'
import { withPublicPageSeo } from '@/modules/seo'

const ChallengesAvailablePageWithSeo = withPublicPageSeo(
  'challengesAvailable',
  AvailableChallengesPage
)

export const Route = createFileRoute('/challenges/available')({
  component: ChallengesAvailablePageWithSeo,
})
